<template>
  <div class="ImageWidget">
    <div :class="['bg flexCenter',{
      noBefore: !content && ctaText
    }]" :style="widgetStyle">
      <div class="text flexCenter" v-html="title">
      </div>
      <a 
        href="#"
        @click.prevent="onDetailBtnClick" 
        class="lens" 
        v-if="content && !ctaText">
        <img src="@images/lens.svg">
      </a>
      <a 
        class="imageClick"
        :href="ctaHref"
        v-if="!content && ctaText"
        :target="dataTarget"
      >&nbsp;</a>
    </div>
    <div class="subTitle" v-if="!!subTitle">
      {{subTitle}}
    </div>
    <div class="imageWidgetLink" v-if="!!ctaText">
      <a :href="ctaHref" @click="onBtnClick" :target="dataTarget">{{ctaText}}</a>
    </div>
  </div>
</template>

<script>
  import EventBus from '../views/event_bus';

  export default {
    name: 'ImageWidget',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      dataTarget: {
        type: String,
        default: "_self"
      },
      title: {
        type: String,
        default: ""
      },
      img: {
        type: String,
        default: ""
      },
      subTitle: {
        type: String,
        default: ""
      },
      ctaText: {
        type: String,
        default: ""
      },
      ctaHref: {
        type: String,
        default: ""
      },
      bgImageStyle: {
        type: Object,
        default: ()=>{
          return {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }
        }
      },
      content: {
        type: String,
        default: ""
      }
    },
    methods: {
      onBtnClick: function(e){
        e.preventDefault();
        if(e.currentTarget.href.indexOf('#') >= 0){
          var event = new CustomEvent('hashClicked', {
            detail: {
              a: e.target
            }
          });
          window.dispatchEvent(event);
        }else{
          window.location.href = e.target.getAttribute('href');
        }
      },
      onDetailBtnClick(){
        EventBus.$emit('content-modal', {
          ...this.$props,
          btnStyle: {
            background: "var(--special-network-color)"
          }
        })
      }
    },
    mounted(){
      console.log('this.ctaText',this.ctaText)
    },
    computed: {
      widgetStyle(){
        return {
          backgroundImage: !!this.img ? `url(${this.img})` : '',
          backgroundSize: !!this.bgImageStyle ? this.bgImageStyle.backgroundSize : 'cover',
          backgroundPosition: !!this.bgImageStyle ? this.bgImageStyle.backgroundPosition : 'center',
          backgroundRepeat: !!this.bgImageStyle ? this.bgImageStyle.backgroundRepeat : 'no-repeat',
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .bg{
    height: 235px;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.3);
    }
    &.noBefore{
      &:before{
        display:none;
      }
    }
  }

  .flexCenter{
    display: flex;
    justify-content: center;
    align-content: stretch;
    flex-direction: column;
    position: relative;
    .imageClick{
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      display: block;
    }
  }

  a{
    font-weight: 600;
  }

  .text{
    flex: 1;
    font-family: Helvetica, sans-serif;
    font-weight: bold;
    font-size: 28px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    /*background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%);*/
  }

  .subTitle, .imageWidgetLink{
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }

  .bg{
    margin-bottom:  22px;
  }

  .subTitle{
    color: #555555;
    margin-top: 22px;
  }
  .imageWidgetLink:link, .imageWidgetLink:visited, .imageWidgetLink:hover, .imageWidgetLink:active{
    color: #614AE4;
    text-decoration: none;
  }

  .lens{
    position: absolute;
    z-index: 1000;
    top: 5px;
    right: 7px;
    width: 43px;
    height: 42px;
    img{ width: 100%; }
  }

</style>
